<template>
  <div class="has-border-b filters filters--company white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="filters-item">
      <MenuItemAutocomplete
        :label="$t(`${namespace}.requester`)"
        type="createdBy"
        :profiles="['Administrator']"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemAutocomplete
        :label="$t(`${namespace}.approver`)"
        type="approvedBy"
        :profiles="['Administrator']"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemPeriod
        :label="$t(`${namespace}.createdDate`)"
        type="startDate"
        :status="status"
        @change="updateFilters"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemDropdown
        :label="$t(`${namespace}.status`)"
        type="status"
        :items="statusList"
        :status="status"
        @change="updateFilters"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { objectToArray } from 'utils/functions'
import MenuItemAutocomplete from 'components/filters/MenuItemAutocomplete'
import MenuItemPeriod from 'components/filters/MenuItemPeriod'
import MenuItemDropdown from 'components/filters/MenuItemDropdown'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  components: {
    MenuItemAutocomplete,
    MenuItemPeriod,
    MenuItemDropdown
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    },

    statusList () {
      return objectToArray(this.$t(`${this.namespace}.filters.statusList`))
    },

    discountTypeList () {
      return objectToArray(this.$t(`${this.namespace}.filters.discountTypeList`))
    }
  },
  data () {
    return {
      namespace: 'Views.IncentivesPage',
      filters: {}
    }
  },
  methods: {
    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    updateFilters (val) {
      this.filters = {
        ...this.filters,
        ...val
      }

      this.emitEvent()
    }
  }
}
</script>

<style lang="scss">
.filters--company {

  .filters-item.filters-item--search {
    width: 310px;
  }
}
</style>
